// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
// Use app-components.shared.module.ts to modify the imports, etc of this module.
// Note: code-generation is optional! See ./.gitignore for directions to remove it,
// if you do not want it.

import { NgModule } from '@angular/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { AppComponentsSharedModule } from './app-components.shared.module';
import { CardExpandingComponent } from './card-expanding/card-expanding.component';
import { CardModuleComponent } from './card-module/card-module.component';
import { CardProductComponent } from './card-product/card-product.component';
import { ContentBlockComponent } from './content-block/content-block.component';
import { CardProductsModuleComponent } from './card-products-module/card-products-module.component';
import { ContentArrayModuleComponent } from './content-array-module/content-array-module.component';
import { DocumentationModuleComponent } from './documentation-module/documentation-module.component';
import { MultiContentModuleComponent } from './multi-content-module/multi-content-module.component';
import { FaqsComponent } from './faqs/faqs.component';
import { FormTextInputComponent } from './form-text-input/form-text-input.component';
import { FormTextAreaComponent } from './form-text-area/form-text-area.component';
import { FormDropdownComponent } from './form-dropdown/form-dropdown.component';
import { FormCheckboxComponent } from './form-checkbox/form-checkbox.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { GraphQLConnectedDemoComponent } from './graph-ql-connected-demo/graph-ql-connected-demo.component';
import { GraphQLIntegratedDemoComponent } from './graph-ql-integrated-demo/graph-ql-integrated-demo.component';
import { GraphQLLayoutComponent } from './graph-ql-layout/graph-ql-layout.component';
import { IntroBlockComponent } from './intro-block/intro-block.component';
import { StyleguideComponentParamsComponent } from './styleguide-component-params/styleguide-component-params.component';
import { StyleguideCustomRouteTypeComponent } from './styleguide-custom-route-type/styleguide-custom-route-type.component';
import { StyleguideEditFrameComponent } from './styleguide-edit-frame/styleguide-edit-frame.component';
import { StyleguideFieldUsageCheckboxComponent } from './styleguide-field-usage-checkbox/styleguide-field-usage-checkbox.component';
import { StyleguideFieldUsageContentListComponent } from './styleguide-field-usage-content-list/styleguide-field-usage-content-list.component';
import { StyleguideFieldUsageCustomComponent } from './styleguide-field-usage-custom/styleguide-field-usage-custom.component';
import { StyleguideFieldUsageDateComponent } from './styleguide-field-usage-date/styleguide-field-usage-date.component';
import { StyleguideFieldUsageFileComponent } from './styleguide-field-usage-file/styleguide-field-usage-file.component';
import { StyleguideFieldUsageImageComponent } from './styleguide-field-usage-image/styleguide-field-usage-image.component';
import { StyleguideFieldUsageItemLinkComponent } from './styleguide-field-usage-item-link/styleguide-field-usage-item-link.component';
import { StyleguideFieldUsageLinkComponent } from './styleguide-field-usage-link/styleguide-field-usage-link.component';
import { StyleguideFieldUsageNumberComponent } from './styleguide-field-usage-number/styleguide-field-usage-number.component';
import { StyleguideFieldUsageRichTextComponent } from './styleguide-field-usage-rich-text/styleguide-field-usage-rich-text.component';
import { StyleguideFieldUsageTextComponent } from './styleguide-field-usage-text/styleguide-field-usage-text.component';
import { StyleguideLayoutComponent } from './styleguide-layout/styleguide-layout.component';
import { StyleguideLayoutReuseComponent } from './styleguide-layout-reuse/styleguide-layout-reuse.component';
import { StyleguideLayoutTabsComponent } from './styleguide-layout-tabs/styleguide-layout-tabs.component';
import { StyleguideLayoutTabsTabComponent } from './styleguide-layout-tabs-tab/styleguide-layout-tabs-tab.component';
import { StyleguideMultilingualComponent } from './styleguide-multilingual/styleguide-multilingual.component';
import { StyleguideRouteFieldsComponent } from './styleguide-route-fields/styleguide-route-fields.component';
import { StyleguideSectionComponent } from './styleguide-section/styleguide-section.component';
import { StyleguideSitecoreContextComponent } from './styleguide-sitecore-context/styleguide-sitecore-context.component';
import { StyleguideTrackingComponent } from './styleguide-tracking/styleguide-tracking.component';
import { TitleBlockBulletsComponent } from './title-block-bullets/title-block-bullets.component';
import { BannerPhotoComponent } from './banner-photo/banner-photo.component';
import { FooterComponent } from './footer/footer.component';
import { MenuComponent } from './menu/menu.component';
import { HeroSliderComponent } from './hero-slider/hero-slider.component';
import { HeroSliderParallaxComponent } from './hero-slider-parallax/hero-slider-parallax.component';
import { BlockPageTitleComponent } from './block-page-title/block-page-title.component';
import { ListRightComponent } from './list-right/list-right.component';
import { ListRightItemComponent } from './list-right-item/list-right-item.component';
import { BannerLogoArrayComponent } from './banner-logo-array/banner-logo-array.component';
import { ComplaintFormComponent } from './complaint-form/complaint-form.component';
import { RichContentComponent } from './rich-content/rich-content.component';
import { RedirectMapComponent } from './redirect-map/redirect-map.component';
import { SearchComponent } from './search/search.component';


@NgModule({
  imports: [
    AppComponentsSharedModule,
    JssModule.withComponents([
      { name: 'CardExpanding', type: CardExpandingComponent },
      { name: 'CardModule', type: CardModuleComponent },
      { name: 'CardProduct', type: CardProductComponent },
      { name: 'ContentBlock', type: ContentBlockComponent },
      { name: 'MultiContentModule', type: MultiContentModuleComponent },
      { name: 'DocumentationModule', type: DocumentationModuleComponent },
      { name: 'ContentArrayModule', type: ContentArrayModuleComponent },
      { name: 'CardProductsModule', type: CardProductsModuleComponent },
      { name: "FAQs", type: FaqsComponent},
      { name: 'FormTextInput', type: FormTextInputComponent },
      { name: 'FormTextArea', type: FormTextAreaComponent },
      { name: 'FormDropdown', type: FormDropdownComponent },
      { name: 'FormCheckbox', type: FormCheckboxComponent },
      { name: 'ContactForm', type: ContactFormComponent },
      { name: 'ComplaintForm', type: ComplaintFormComponent },
      { name: 'GraphQLConnectedDemo', type: GraphQLConnectedDemoComponent },
      { name: 'GraphQLIntegratedDemo', type: GraphQLIntegratedDemoComponent },
      { name: 'GraphQLLayout', type: GraphQLLayoutComponent },
      { name: 'IntroBlock', type: IntroBlockComponent },
      { name: 'StyleguideComponentParams', type: StyleguideComponentParamsComponent },
      { name: 'StyleguideCustomRouteType', type: StyleguideCustomRouteTypeComponent },
      { name: 'StyleguideEditFrame', type: StyleguideEditFrameComponent },
      { name: 'StyleguideFieldUsageCheckbox', type: StyleguideFieldUsageCheckboxComponent },
      { name: 'StyleguideFieldUsageContentList', type: StyleguideFieldUsageContentListComponent },
      { name: 'StyleguideFieldUsageCustom', type: StyleguideFieldUsageCustomComponent },
      { name: 'StyleguideFieldUsageDate', type: StyleguideFieldUsageDateComponent },
      { name: 'StyleguideFieldUsageFile', type: StyleguideFieldUsageFileComponent },
      { name: 'StyleguideFieldUsageImage', type: StyleguideFieldUsageImageComponent },
      { name: 'StyleguideFieldUsageItemLink', type: StyleguideFieldUsageItemLinkComponent },
      { name: 'StyleguideFieldUsageLink', type: StyleguideFieldUsageLinkComponent },
      { name: 'StyleguideFieldUsageNumber', type: StyleguideFieldUsageNumberComponent },
      { name: 'StyleguideFieldUsageRichText', type: StyleguideFieldUsageRichTextComponent },
      { name: 'StyleguideFieldUsageText', type: StyleguideFieldUsageTextComponent },
      { name: 'StyleguideLayout', type: StyleguideLayoutComponent },
      { name: 'StyleguideLayoutReuse', type: StyleguideLayoutReuseComponent },
      { name: 'StyleguideLayoutTabs', type: StyleguideLayoutTabsComponent },
      { name: 'StyleguideLayoutTabsTab', type: StyleguideLayoutTabsTabComponent },
      { name: 'StyleguideMultilingual', type: StyleguideMultilingualComponent },
      { name: 'StyleguideRouteFields', type: StyleguideRouteFieldsComponent },
      { name: 'StyleguideSection', type: StyleguideSectionComponent },
      { name: 'StyleguideSitecoreContext', type: StyleguideSitecoreContextComponent },
      { name: 'StyleguideTracking', type: StyleguideTrackingComponent },
      { name: 'TitleBlockBullets', type: TitleBlockBulletsComponent },
      { name: 'BannerPhoto', type: BannerPhotoComponent },
      { name: 'Footer' , type: FooterComponent },
      { name: 'Menu' , type: MenuComponent },
      { name: 'HeroSlider' , type: HeroSliderComponent },
      { name: 'HeroSliderParallax' , type: HeroSliderParallaxComponent },
      { name: 'BlockPageTitle' , type: BlockPageTitleComponent },
      { name: 'ListRight' , type: ListRightComponent },
      { name: 'ListRightItem' , type: ListRightItemComponent },
      { name: 'BannerLogoArray' , type: BannerLogoArrayComponent },
      { name: 'RichContent' , type: RichContentComponent },
      { name: 'RedirectMap' , type: RedirectMapComponent },
      { name: 'Search' , type: SearchComponent },
    ], 
    [
      // { path: 'StyleguideAngularLazyLoading', loadChildren: () => import('./styleguide-angular-lazy-loading/styleguide-angular-lazy-loading.module').then(m => m.StyleguideAngularLazyLoadingModule) },
      // { path: 'ListRight', loadChildren: () => import('./list-right/list-right.module').then(m => m.ListRightModule) },
      // { path: 'ListRightItem', loadChildren: () => import('./list-right-item/list-right-item.module').then(m => m.ListRightItemModule) },
      // { path: 'BannerLogoArray', loadChildren: () => import('./banner-logo-array/banner-logo-array.module').then(m => m.BannerLogoArrayModule) },
      { path: 'AppPromo', loadChildren: () => import('./app-promo/app-promo.module').then(m => m.AppPromoModule) },
      { path: 'StatsSection', loadChildren: () => import('./stats-section/stats-section.module').then(m => m.StatsSectionModule) },
      { path: 'Accordion', loadChildren: () => import('./accordion/accordion.module').then(m => m.AccordionModule) },
      { path: 'AccordionItem', loadChildren: () => import('./accordion-item/accordion-item.module').then(m => m.AccordionItemModule) },
      //{ path: 'RichContent', loadChildren: () => import('./rich-content/rich-content.module').then(m => m.RichContentModule) },
      { path: 'Video', loadChildren: () => import('./video/video.module').then(m => m.VideoModule) },
    ]),
  ],
  exports: [
    JssModule,
    AppComponentsSharedModule,
  ],
  declarations: [
    CardProductsModuleComponent,
    ContentArrayModuleComponent,
    DocumentationModuleComponent,
    MultiContentModuleComponent,
    ContentBlockComponent,
    FaqsComponent,
    ContactFormComponent,
    ComplaintFormComponent,
    GraphQLConnectedDemoComponent,
    GraphQLIntegratedDemoComponent,
    GraphQLLayoutComponent,
    IntroBlockComponent,
    StyleguideComponentParamsComponent,
    StyleguideCustomRouteTypeComponent,
    StyleguideEditFrameComponent,
    StyleguideFieldUsageCheckboxComponent,
    StyleguideFieldUsageContentListComponent,
    StyleguideFieldUsageCustomComponent,
    StyleguideFieldUsageDateComponent,
    StyleguideFieldUsageFileComponent,
    StyleguideFieldUsageImageComponent,
    StyleguideFieldUsageItemLinkComponent,
    StyleguideFieldUsageLinkComponent,
    StyleguideFieldUsageNumberComponent,
    StyleguideFieldUsageRichTextComponent,
    StyleguideFieldUsageTextComponent,
    StyleguideLayoutComponent,
    StyleguideLayoutReuseComponent,
    StyleguideLayoutTabsComponent,
    StyleguideLayoutTabsTabComponent,
    StyleguideMultilingualComponent,
    StyleguideRouteFieldsComponent,
    StyleguideSectionComponent,
    StyleguideSitecoreContextComponent,
    StyleguideTrackingComponent,
    TitleBlockBulletsComponent,
    BannerPhotoComponent,
    FooterComponent,
    MenuComponent,
    HeroSliderComponent,
    HeroSliderParallaxComponent,
    BlockPageTitleComponent,
    ListRightComponent,
    ListRightItemComponent,
    BannerLogoArrayComponent,
    RichContentComponent,
    RedirectMapComponent,
    SearchComponent
  ],
})
export class AppComponentsModule { }
